/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Commission_Note_BeforeInputs */

const es_ab_commission_note_before = /** @type {(inputs: Ab_Commission_Note_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La comisión `)
};

const gl_ab_commission_note_before = /** @type {(inputs: Ab_Commission_Note_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A comisión `)
};

const en_ab_commission_note_before = /** @type {(inputs: Ab_Commission_Note_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The market's `)
};

/**
* | output |
* | --- |
* | "The market's" |
*
* @param {Ab_Commission_Note_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_commission_note_before = /** @type {((inputs?: Ab_Commission_Note_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Commission_Note_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_commission_note_before(inputs)
	if (locale === "en") return en_ab_commission_note_before(inputs)
	return es_ab_commission_note_before(inputs)
});